/*
 * PANORAMA — Fiche produit (chargé par sections/main-product.liquid)
 *
 * - Encart Alma (snippets/pano-pdp-alma.liquid) : montants des cases 3× / 4× recalculés depuis le prix de
 *   la variante en centimes à chaque changement de taille (jamais depuis le texte affiché). Affiché en
 *   euros, si dispo et 100 € ≤ prix ≤ 2 000 €.
 * - Carte « Authenticité garantie » (snippets/pano-pdp-trust.liquid) : contenu propre au produit, masquée
 *   comme la réassurance quand la variante est vendue.
 * - Taille obligatoire : aucune taille présélectionnée ; bouton principal et paiement express
 *   bloqués tant qu'aucune taille n'est choisie.
 * - Réassurance sous les boutons (snippets/pano-pdp-trust.liquid) : rendue par le serveur pour la variante
 *   choisie (livraison offerte ou 9,90 € selon le prix, « En stock · expédiée sous 48 h » /
 *   « Précommande · expédiée sous 5 à 12 jours ouvrés », retrait en boutique selon le stock du magasin).
 *   À chaque changement de taille, la liste est reprise de la réponse de section reçue par
 *   product-info.js ; les dates « reçue entre le … et le … » sont recalculées avec la date du visiteur.
 *   Liste et bouton WhatsApp masqués si la variante est vendue (bloc contact affiché à la place,
 *   sauf pièce unique vendue : voir snippets/pano-pdp-sold.liquid).
 * - Barre d'achat mobile (≤ 749 px) quand le bouton principal est sorti de l'écran, avec remontée
 *   de la bulle de chat Shopify Inbox (classe body.pano-sticky-on, voir assets/pano-pdp.css).
 * - Avis Google : remplissage de la dernière étoile selon la vraie note (4,2 et non 4,5).
 *
 * Les données serveur (statut de chaque variante, prix en centimes…) sont lues dans
 * <script type="application/json" data-pano-pdp> rendu par snippets/pano-pdp-sticky.liquid.
 */
(function () {
  'use strict';

  if (window.__panoPdpLoaded) return;
  window.__panoPdpLoaded = true;

  var NBSP = ' ';
  var NNBSP = ' ';
  var MOBILE_QUERY = '(max-width: 749px)';

  /*
   * Dates « reçue entre le … et le … » : nombre de jours ouvrés (hors samedi et dimanche) porté par
   * l'attribut data-pano-days de snippets/pano-pdp-trust.liquid (1 et 5 pour la France).
   */
  var DAYS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  var MONTHS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];

  /* 25333 -> "253,33 €" ; 345000 -> "3 450 €" (même règle que snippets/pano-pdp-eur.liquid) */
  function eur(cents) {
    var c = Math.round(Number(cents) || 0);
    var e = Math.floor(c / 100);
    var r = c % 100;
    var s = String(e).replace(/\B(?=(\d{3})+(?!\d))/g, NNBSP);
    if (r) s += ',' + (r < 10 ? '0' : '') + r;
    return s + NBSP + '€';
  }

  function addBusinessDays(date, n) {
    var d = new Date(date);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  /* « ven. 9 oct. » (espaces insécables, comme le rendu serveur) */
  function fmtDate(d) {
    return DAYS[d.getDay()] + NBSP + d.getDate() + NBSP + MONTHS[d.getMonth()];
  }

  function toggle(el, show) {
    if (!el) return;
    if (show) {
      el.hidden = false;
      el.style.display = '';
    } else {
      el.hidden = true;
      el.style.display = 'none';
    }
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function PanoPdp(dataEl) {
    this.data = JSON.parse(dataEl.textContent);
    this.sectionId = this.data.sectionId;
    this.needsSize = !!this.data.needsSize;
    this.sizeTouched = false;
    this.pastButtons = false;
    this.lastVariant = null;
    this.mobile = window.matchMedia(MOBILE_QUERY);
    this.init();
  }

  PanoPdp.prototype.byId = function (prefix) {
    return document.getElementById(prefix + '-' + this.sectionId);
  };

  PanoPdp.prototype.root = function () {
    return document.getElementById('MainProduct-' + this.sectionId);
  };

  PanoPdp.prototype.form = function () {
    return document.getElementById(this.data.formId);
  };

  PanoPdp.prototype.productFormEl = function () {
    var form = this.form();
    return form ? form.closest('product-form') : null;
  };

  PanoPdp.prototype.currentVariantId = function () {
    var form = this.form();
    var input = form ? form.querySelector('input[name="id"]') : null;
    return input && input.value ? String(input.value) : null;
  };

  PanoPdp.prototype.status = function () {
    var id = this.currentVariantId();
    return id ? this.data.variants[id] || null : null;
  };

  PanoPdp.prototype.isAvailable = function () {
    var st = this.status();
    return !!(st && st.available);
  };

  PanoPdp.prototype.init = function () {
    var self = this;

    this.initSticky();

    /*
     * Choix d'une taille : on attend que product-info.js ait mis à jour le champ id du formulaire
     * (nouvelle variante) avant de déverrouiller le bouton et le paiement express.
     */
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest('#variant-selects-' + self.sectionId)) {
        self.sizeTouched = true;
        return;
      }
      /* Champ id du formulaire principal (mis à jour par product-info.js après le choix) */
      if (target.name === 'id' && target.closest('#' + self.data.formId)) {
        self.update();
      }
    });

    /* Après la mise à jour de la fiche (prix, bouton…) par product-info.js */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || event.data.sectionId !== self.sectionId) return;
        self.lastVariant = event.data.variant || null;
        self.syncTrust(event.data.html);
        self.update();
      });
    }

    /* Envoi du formulaire alors qu'aucune taille n'est choisie (voir assets/product-form.js) */
    document.addEventListener('pano:needs-size', function () {
      self.scrollToPicker();
    });

    this.update();
  };

  /* Prix de la variante courante en centimes : JSON de la variante, sinon données serveur */
  PanoPdp.prototype.currentPrice = function () {
    var id = this.currentVariantId();
    if (this.lastVariant && String(this.lastVariant.id) === id && typeof this.lastVariant.price === 'number') {
      return this.lastVariant.price;
    }
    var st = this.status();
    return st ? st.price : null;
  };

  PanoPdp.prototype.almaEligible = function () {
    /* Alma n'est proposé qu'en euros */
    if (this.data.currency !== 'EUR') return false;
    var st = this.status();
    if (!st || !st.available) return false;
    if (this.needsSize && this.data.priceVaries) return false;
    var cents = this.currentPrice();
    return typeof cents === 'number' && cents >= this.data.almaMin && cents <= this.data.almaMax;
  };

  PanoPdp.prototype.update = function () {
    if (this.sizeTouched) this.needsSize = false;
    this.renderBlocks();
    this.renderTrust();
    this.renderNeedsSize();
    this.renderAlma();
    this.renderSticky();
  };

  /* Bouton, carte authenticité, réassurance, bouton WhatsApp et bloc contact selon la disponibilité de la variante */
  PanoPdp.prototype.renderBlocks = function () {
    var st = this.status();
    var available = !!(st && st.available);
    var submit = this.byId('ProductSubmitButton');
    if (submit) submit.style.display = available ? '' : 'none';
    toggle(this.byId('PanoExpress'), available);
    toggle(this.byId('PanoAuth'), available);
    toggle(this.byId('PanoTrust'), available);
    toggle(this.byId('PanoWa'), available);
    toggle(this.byId('SoldoutContact'), !available);
  };

  /*
   * Nouvelle taille : la réassurance rendue par le serveur pour cette variante (tarif selon son prix,
   * 48 h / précommande, retrait selon le stock du magasin) remplace l'ancienne.
   */
  PanoPdp.prototype.syncTrust = function (html) {
    if (!html || typeof html.getElementById !== 'function') return;
    var current = this.byId('PanoTrust');
    var fresh = html.getElementById('PanoTrust-' + this.sectionId);
    if (current && fresh) current.innerHTML = fresh.innerHTML;
  };

  /* Dates de réception recalculées avec la date du visiteur (le rendu serveur peut dater du cache) */
  PanoPdp.prototype.renderTrust = function () {
    var list = this.byId('PanoTrust');
    if (!list) return;
    var today = new Date();
    list.querySelectorAll('[data-pano-days]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-pano-days'), 10);
      if (n > 0) el.textContent = fmtDate(addBusinessDays(today, n));
    });
  };

  /* Taille pas encore choisie : bouton désactivé, paiement express verrouillé */
  PanoPdp.prototype.renderNeedsSize = function () {
    var locked = this.needsSize && this.isAvailable();
    var productForm = this.productFormEl();
    if (productForm) productForm.dataset.panoNeedsSize = locked ? 'true' : 'false';

    var submit = this.byId('ProductSubmitButton');
    if (submit && locked) {
      submit.setAttribute('disabled', 'disabled');
      var label = submit.querySelector('span');
      if (label) label.textContent = 'Choisissez votre taille';
    }

    var express = this.byId('PanoExpress');
    if (express) {
      if (locked) {
        express.setAttribute('inert', '');
        express.classList.add('is-locked');
      } else {
        express.removeAttribute('inert');
        express.classList.remove('is-locked');
      }
    }

    var hint = document.querySelector('#variant-selects-' + this.sectionId + ' [data-pano-size-hint]');
    if (hint) hint.hidden = !locked;

    if (this.stickyBtn) this.stickyBtn.textContent = locked ? 'Choisir ma taille' : 'Ajouter au panier';
  };

  /* Encart Alma : seul le montant de chaque case change (« 3× » / « 4× » restent fixes) */
  PanoPdp.prototype.renderAlma = function () {
    var box = this.byId('PanoAlma');
    if (!box) return;
    var show = this.almaEligible();
    box.hidden = !show;
    if (!show) return;
    var cents = this.currentPrice();
    [3, 4].forEach(function (n) {
      var el = box.querySelector('[data-alma-n="' + n + '"]');
      if (el) el.textContent = eur(Math.floor(cents / n));
    });
  };

  /* ---------- Barre d'achat mobile ---------- */

  PanoPdp.prototype.initSticky = function () {
    var self = this;
    this.sticky = this.byId('PanoSticky');
    if (!this.sticky) return;
    this.stickyBtn = this.sticky.querySelector('[data-pano-sticky-btn]');
    this.stickyPrice = this.sticky.querySelector('[data-pano-sticky-price]');
    this.stickyAlma = this.sticky.querySelector('[data-pano-sticky-alma]');
    this.stickyAlmaAmount = this.sticky.querySelector('[data-pano-sticky-alma-amount]');

    this.stickyBtn.addEventListener('click', function () {
      self.onStickyClick();
    });

    var root = this.root();
    var target = root ? root.querySelector('.product-form__buttons') : null;
    if (target && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[entries.length - 1];
          /* Visible seulement une fois le bouton principal dépassé (au-dessus de l'écran) */
          self.pastButtons = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          self.renderStickyVisibility();
        },
        { threshold: 0 }
      );
      this.observer.observe(target);
    }

    var onMediaChange = function () {
      self.renderStickyVisibility();
    };
    if (this.mobile.addEventListener) this.mobile.addEventListener('change', onMediaChange);
    else if (this.mobile.addListener) this.mobile.addListener(onMediaChange);
  };

  PanoPdp.prototype.renderSticky = function () {
    if (!this.sticky) return;

    /* Prix : recopie du prix principal (même format que la fiche, quel que soit le format boutique) */
    var priceWrap = document.getElementById('price-' + this.sectionId);
    if (priceWrap && this.stickyPrice) {
      var priceEl = priceWrap.querySelector('.price');
      var item = null;
      if (priceEl && priceEl.classList.contains('price--on-sale')) {
        item = priceWrap.querySelector('.price__sale .price-item--sale');
      }
      if (!item) item = priceWrap.querySelector('.price__regular .price-item--regular');
      var text = item ? item.textContent.replace(/\s+/g, ' ').trim() : '';
      if (text) this.stickyPrice.textContent = text;
    }

    if (this.stickyAlma) {
      var eligible = this.almaEligible();
      this.stickyAlma.hidden = !eligible;
      if (eligible && this.stickyAlmaAmount) this.stickyAlmaAmount.textContent = eur(Math.floor(this.currentPrice() / 3));
    }

    this.renderStickyVisibility();
  };

  PanoPdp.prototype.renderStickyVisibility = function () {
    if (!this.sticky) return;
    var show = this.mobile.matches && this.pastButtons && this.isAvailable();
    this.sticky.classList.toggle('is-visible', show);
    if (show) {
      this.sticky.removeAttribute('inert');
      this.sticky.setAttribute('aria-hidden', 'false');
    } else {
      this.sticky.setAttribute('inert', '');
      this.sticky.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.toggle('pano-sticky-on', show);
  };

  PanoPdp.prototype.onStickyClick = function () {
    if (this.needsSize) {
      this.scrollToPicker();
      return;
    }
    var submit = this.byId('ProductSubmitButton');
    if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') {
      var buttons = this.root() && this.root().querySelector('.product-form__buttons');
      if (buttons) buttons.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
      return;
    }
    /* Déclenche le vrai bouton du formulaire produit (ajout au panier AJAX du thème) */
    submit.click();
  };

  PanoPdp.prototype.scrollToPicker = function () {
    var picker = document.getElementById('variant-selects-' + this.sectionId);
    if (!picker) return;
    var fieldset = picker.querySelector('[data-pano-size]') || picker;
    fieldset.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
    fieldset.classList.remove('pano-size-flash');
    void fieldset.offsetWidth;
    fieldset.classList.add('pano-size-flash');
    var first = fieldset.querySelector('input[type="radio"]:not(.disabled), input[type="radio"], select');
    if (first) {
      try {
        first.focus({ preventScroll: true });
      } catch (e) {
        /* navigateurs sans preventScroll */
      }
    }
  };

  /*
   * Avis Google (section avis-clients) : une note de 4,2 affichait une demi-étoile, soit 4,5 visuellement.
   * La dernière étoile est remplie selon la vraie décimale (l'étoile occupe x = 2,6 → 17,4 de sa viewBox 20 × 20).
   */
  function fixReviewStars() {
    document.querySelectorAll('.trust-reviews__rating-row').forEach(function (row) {
      var num = row.querySelector('.trust-reviews__rating-number');
      var part = row.querySelector('.star__fill--half');
      if (!num || !part) return;
      var rating = parseFloat(num.textContent.replace(',', '.'));
      if (!(rating > 0)) return;
      var fraction = rating - Math.floor(rating);
      var right = Math.max(0, Math.min(100, 87 - 74 * fraction));
      part.style.clipPath = 'inset(0 ' + right.toFixed(1) + '% 0 0)';
    });
  }

  function boot() {
    try {
      fixReviewStars();
    } catch (e) {
      /* sans effet sur le reste de la fiche */
    }
    document.querySelectorAll('script[data-pano-pdp]').forEach(function (el) {
      if (el.dataset.panoReady) return;
      el.dataset.panoReady = 'true';
      try {
        new PanoPdp(el);
      } catch (e) {
        console.error('[pano-pdp]', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
/*
 * PANORAMA — « Découvrez également » (sections/related-products.liquid) sans décalage de mise en page.
 * Dawn charge ces produits quand on arrive à 400 px de la section : la grille (jusqu'à 8 cartes, environ
 * 1 300 px sur mobile) apparaît alors pendant la lecture et pousse les avis Google vers le bas
 * (CLS mesuré au défilement : 0,15 à 0,78 sur mobile).
 * 1. Chargement anticipé dès que la page est inactive après son chargement, quand la section est encore loin.
 * 2. Sur mobile, la place reste réservée (assets/pano-pdp.css) jusqu'à la fin du chargement : classe
 *    pano-reco-settled, posée aussi en cas d'échec ou de liste vide.
 * Le contenu reçu est traité exactement comme dans assets/global.js (ProductRecommendations).
 */
(function () {
  'use strict';
  var Reco = window.customElements && window.customElements.get('product-recommendations');
  if (!Reco || Reco.prototype.__panoReco) return;
  Reco.prototype.__panoReco = true;

  Reco.prototype.loadRecommendations = function (productId) {
    var self = this;
    if (self.__panoLoading) return;
    self.__panoLoading = true;
    if (self.observer) self.observer.unobserve(self);
    fetch(self.dataset.url + '&product_id=' + productId + '&section_id=' + self.dataset.sectionId)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var recommendations = html.querySelector('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          self.innerHTML = recommendations.innerHTML;
        }
        if (!self.querySelector('slideshow-component') && self.classList.contains('complementary-products')) {
          self.remove();
        }
        if (html.querySelector('.grid__item')) {
          self.classList.add('product-recommendations--loaded');
        }
      })
      .catch(function (e) {
        console.error(e);
      })
      .then(function () {
        self.classList.add('pano-reco-settled');
      });
  };

  function loadEarly() {
    document.querySelectorAll('product-recommendations.related-products').forEach(function (el) {
      if (el.__panoLoading || el.classList.contains('product-recommendations--loaded')) return;
      if (typeof el.loadRecommendations !== 'function' || !el.dataset.productId) return;
      el.loadRecommendations(el.dataset.productId);
    });
  }

  function schedule() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadEarly, { timeout: 4000 });
    } else {
      setTimeout(loadEarly, 2000);
    }
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }
})();
